import React from 'react';
import { motion } from 'framer-motion';
import { FiEye, FiHeart, FiMapPin, FiCalendar } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../i18n/LanguageContext';

const Highlights = () => {
  const { t } = useLanguage();
  const highlightTitles = t('highlights.items');

  const highlights = [
    { icon: FiEye, title: highlightTitles?.[0] || 'Personalized lash sets' },
    { icon: FiHeart, title: highlightTitles?.[1] || 'Cozy private studio' },
    { icon: FiMapPin, title: highlightTitles?.[2] || 'West Island location' },
    { icon: FiCalendar, title: highlightTitles?.[3] || 'Easy online booking' },
  ];

  return (
    <section className="py-16 bg-brand-cream border-b border-brand-sand">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {highlights.map((item, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex flex-col items-center text-center gap-4"
            >
              <div className="w-12 h-12 bg-brand-sand rounded-full flex items-center justify-center text-brand-taupe">
                <SafeIcon icon={item.icon} className="w-5 h-5" />
              </div>
              <p className="text-brand-dark font-medium text-sm md:text-base">
                {item.title}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Highlights;
